export const isMobile = () => {
  return window.innerWidth <= 768;
};

export const isDesktop = () => {
  return window.innerWidth > 768;
};
